import { datadogRum } from '@datadog/browser-rum'

/**
 * Report a response that did not match its schema, under the `report` policy.
 *
 * In a browser with Datadog RUM initialised, it sends the RUM action
 * `api.contract_mismatch` and warns in the console. Everywhere else (RSC, route
 * handlers, local dev where RUM is off) it writes one structured
 * `[api.contract_mismatch]` line to `console.error`, which Vercel's runtime
 * logs capture. It sends the endpoint and the first three issue paths, never
 * the payload.
 */
export function reportContractMismatch(endpoint: string, issues: ReadonlyArray<{ path: PropertyKey[] }>): void {
  const paths = issues.slice(0, 3).map(issue => issue.path.map(String).join('.'))

  if (typeof window !== 'undefined' && datadogRum.getInitConfiguration()) {
    datadogRum.addAction('api.contract_mismatch', { endpoint, paths })
    console.warn('[api.contract_mismatch]', { endpoint, paths })
    return
  }

  console.error('[api.contract_mismatch]', { endpoint, paths })
}
